import React, { Fragment, memo, useState } from "react";
import { Flex, Text, SimpleGrid, useDisclosure } from "@chakra-ui/react";
import { listPriceList } from "@/constants/alohainfo-contants";
import PriceItemComponent from './priceitem'
import PricingModal from "@/components/modal/pricing-modal";
function PricingComponent() {
   const { isOpen, onOpen, onClose } = useDisclosure();
   const [type,setType] = useState(false)
   return (
      <Flex
         flexDir={"column"}
         w={{ base: "90%", BREAK_PAD: "740px", BREAK_LPC: "960px", BREAK_PC: "1280px" }}
         mx={"auto"}
         alignItems="center">
         <Text
            fontSize={{ base: 24, BREAK_LPC: 34 }}
            color="#000"
            fontFamily={{ base: "Arial-BoldMT", BREAK_LPC: "Arial" }}
            mt={{ base: "60px",BREAK_PAD:'90px', BREAK_LPC: "120px" }}>
            Pricing
         </Text>
         <Text mt={"20px"} color="#333" fontSize={{ base: 18, BREAK_LPC: 20 }} textAlign={"center"}>
            Boost your NFT sales and build a larger community!
         </Text>
         <SimpleGrid
            mt={{ base: "35px", BREAK_LPC: "70px" }}
            mb={{ base: "60px", BREAK_LPC: "120px" }}
            columns={{ base: 1,BREAK_PAD:3 }}
            gridGap={"20px"}
            mx={"auto"}>
            {listPriceList.map((item, index) => {
               return (
                  <Fragment key={index}>
                     <PriceItemComponent item={item} warning={e=>{
                        setType(e)
                        onOpen()
                     }}/>
                  </Fragment>
               );
            })}
         </SimpleGrid>
         {isOpen && <PricingModal isOpen={isOpen} onClose={onClose} type={type}/>}
      </Flex>
   );
}
export default memo(PricingComponent);
